import React from 'react';
import { ComponentProps, inject, deps, observer } from '../../../../lib/component';
import { TopSolutionCarousel, TopSolutionEntity } from '../TopSolutionCarousel';
import { LinkTile } from '../../molecules/LinkTile';
import { style } from 'typestyle';
import { rebrand } from '../../../../theme/color';
import { important, px } from 'csx';
import { mediaDesktop, mediaUpToDesktop } from '../../utilities/mediaQueries';

const styles = {
  titleWrapper: style({
    display: 'flex',
    alignItems: 'center',
    height: '25px',
  }),
  topSolutionTitle: style(
    mediaDesktop({
      width: '25%',
    }),
    mediaUpToDesktop({
      width: '42.5%',
      paddingLeft: '16px',
    })
  ),
  tracktile: style(
    mediaUpToDesktop({
      width: px(150),
      height: px(213),
      $nest: {
        '&> div > a > img': {
          width: '100%',
          height: px(150),
        },
      },
    }),
    {
      width: px(224),
      height: px(282),
      $nest: {
        '&> div > a > img': {
          width: '100%',
          height: px(224),
        },
      },
    }
  ),
  topSolutionWrapper: style({
    width: '100%',
    height: 'auto',
    backgroundColor: rebrand.neutralOnDark[10].toString(),
    padding: '32px 0',
  }),
  topSolutionContainer: style({
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  }),
  tilesWrapper: style({
    paddingTop: px(32),
  }),
  topsolutionSpacing: style({
    paddingBottom: important('0px'),
  }),
};

export const ValidatedResults: React.FC<ComponentProps> = inject(deps)(
  observer(
    ({
      model: {
        page: {
          searchMvp: { selectedSuggestion, formattedValidatedSearchResults },
        },
        env: { baseUrl },
        image: { cover },
      },
      controller: { analytics },
    }) => {
      const selectTopSolutionMixPanel = (category: string, selectedTileUrl: string) => {
        analytics.sendMixpanel('User selects a top result', {
          category,
          selectedTileUrl: `${baseUrl}/${selectedTileUrl}`,
        });
      };

      if (['artist', 'playlist', 'track'].includes(selectedSuggestion.type)) {
        return (
          <TopSolutionCarousel
            perPage={4}
            selectedEntity={selectedSuggestion.type}
            onSelectTopSolution={selectTopSolutionMixPanel}
            className={styles.topsolutionSpacing}
            topSolutions={formattedValidatedSearchResults as TopSolutionEntity[]}
          />
        );
      }

      return (
        <div className={styles.topSolutionContainer}>
          <div className={styles.tilesWrapper}>
            {selectedSuggestion.type === 'genre' && selectedSuggestion.images.identity && (
              <div className={styles.tracktile} data-test-top-solution={'genre'}>
                <LinkTile
                  square
                  compact
                  heading={selectedSuggestion.name}
                  href={`/browse/genres/${selectedSuggestion.slug}`}
                  src={cover(selectedSuggestion.images.identity)}
                  isSearchPage
                  type={'Genre'}
                />
              </div>
            )}
            {selectedSuggestion.type === 'mood' && selectedSuggestion.images.identity && (
              <div className={styles.tracktile} data-test-top-solution={'mood'}>
                <LinkTile
                  square
                  compact
                  heading={selectedSuggestion.name}
                  href={`/browse/moods/${selectedSuggestion.slug}`}
                  src={cover(selectedSuggestion.images.identity)}
                  isSearchPage
                  type={'Mood'}
                />
              </div>
            )}
          </div>
        </div>
      );
    }
  )
);
